/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { config } from "./shared.config";

// You can modify or replace module config here

import { DJIVUserMenuComponent } from "./components/djiv-user-menu/djiv-user-menu.component";
import { NgModule } from "@angular/core";
import { DJIVHeaderPanelComponent } from "./components/djiv-header-panel/djiv-header-panel.component";
import { DJIVNavItem } from "./components/djiv-nav-item/djiv-nav-item.component";
import { DJIVLanguagesDropDown } from "./components/djiv-languages-drop-down/djiv-languages-drop-down.component";
import { DJIVLoginForm } from "./components/djiv-login-form/djiv-login-form.component";
import { DJIVForgotPasswordForm } from "./components/djiv-forgot-password-form/djiv-forgot-password-form.component";
import { DJIVTablesModule } from "./components/djiv-tables/djiv-tables.module";
import { DJIVFilterMenu } from "./components/djiv-filter-menu/djiv-filter-menu.component";
import { DJIVResetPasswordForm } from "./components/djiv-reset-password-form/djiv-reset-password-form.component";
import { DjivVideoPanel } from "./components/djiv-video-panel/djiv-video-panel.component";
import { DjivAccountActivationComponent } from "./components/djiv-account-activation/djiv-account-activation.component";
import { DJIVGroupBookingDetailTableComponent } from "./components/djiv-tables/djiv-group-booking-detail-table/djiv-group-booking-detail-table.component";
import { FormatDatePipe } from "./pipes/format-date.pipe";
import { KbToNotificationIconPipe } from "../core/notification/to-notification-icon.pipe";
import { NotificationComponent } from "../core/notification/notification.component";
import { DJIVGroupServiceDetailTableComponent } from "./components/djiv-tables/djiv-group-service-detail-table/djiv-group-service-detail-table.component";
import { DJIVBookingDetailTableComponent } from "./components/djiv-tables/djiv-booking-detail-table/djiv-booking-detail-table.component";

config.declarations.push(DJIVUserMenuComponent);
config.declarations.push(DJIVHeaderPanelComponent);
config.declarations.push(DJIVLanguagesDropDown);
config.declarations.push(DJIVNavItem);
config.declarations.push(DJIVLoginForm);
config.declarations.push(DJIVForgotPasswordForm);
config.declarations.push(DJIVResetPasswordForm);
config.declarations.push(DJIVFilterMenu);
config.declarations.push(DjivVideoPanel);
config.declarations.push(DjivAccountActivationComponent);
config.declarations.push(DJIVGroupBookingDetailTableComponent);
config.declarations.push(DJIVBookingDetailTableComponent);
config.declarations.push(DJIVGroupServiceDetailTableComponent);
config.declarations.push(FormatDatePipe);
config.declarations.push(NotificationComponent);
config.declarations.push(KbToNotificationIconPipe);

config.exports.push(DjivVideoPanel);
config.exports.push(DJIVUserMenuComponent);
config.exports.push(DJIVHeaderPanelComponent);
config.exports.push(DJIVLanguagesDropDown);
config.exports.push(DJIVNavItem);
config.exports.push(DJIVLoginForm);
config.exports.push(DJIVForgotPasswordForm);
config.exports.push(DJIVResetPasswordForm);
config.exports.push(DJIVFilterMenu);
config.exports.push(DjivAccountActivationComponent);
config.exports.push(DJIVGroupBookingDetailTableComponent);
config.exports.push(DJIVBookingDetailTableComponent);
config.exports.push(DJIVGroupServiceDetailTableComponent);
config.exports.push(FormatDatePipe);
config.exports.push(NotificationComponent);

export const newConfig: NgModule = config;



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/shared.custom-config.ts